<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import PageHeader from "~/components/layout/PageHeader.vue";
import HorizontalImageSlider from "~/components/about/HorizontalImageSlider.vue";
import OurClientsGrid from "~/components/about/OurClientsGrid.vue";
import {CONTACTS} from "~/configs/contacts";
import ymaps from "ymaps";
import {CERTIFICATES} from "~/data/certificates";
import {RECOMMENDATIONS_ARRAY} from "~/data/recommendations";

definePageMeta({
  layout: "default",
  name: "about",
});

useHead(getMeta(
    `XSQUARE`,
    `XSQUARE`,
));

useJsonld({
  "@context": "https://schema.org",
  "@type": "Organization",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Россия, г. Москва",
    "postalCode": "105066",
    "streetAddress": "Нижняя Красносельская ул., дом 35 стр. 9, БЦ Manhattan, Lobby 2"
  },
  "contactPoint" : [
    {
      "@type" : "ContactPoint",
      "telephone" : CONTACTS.phone,
      "contactType" : "Поддержка и консультация клиентов"
    }
  ],
  "email": CONTACTS.email,
  "name": "Хи-квадрат",
  "telephone": CONTACTS.phone,
  "logo": "/logo.svg"
})

onMounted(() => {
  ymaps.load().then((maps: any) => {
    const coordinates = [55.775984, 37.673679];
    const map = new maps.Map("yandexMaps", {
      center: coordinates,
      zoom: 17,
      controls: []
    });

    map.behaviors.disable('scrollZoom')
    const placemark = new maps.Placemark(
      coordinates,
      {
        iconCaption: "ХИ-КВАДРАТ",
        iconLayout: "default#image",
      },
      {
        iconLayout: "default#image",
        iconImageHref: "/images/map-pin.svg",
        iconImageSize: [60, 60],
        iconImageOffset: [-10, -78],
      }
    );
    map.geoObjects.add(placemark);
  });
})
</script>

<template>
  <div class="about-page-header about-page" >
    <page-header
      h1="About us"
    >
      <template #content>
        <div class="main-page-header-description">
          <h2>
            XSQUARE is the developer of the only low-cost code platform based on PostgreSQL.
          </h2>

          <p>
            The development of our own platform has become a response to modern demands for an effective approach to creating information systems and applications.
          </p>

          <p>
            Many years of experience have allowed us to create a platform that exceeds the speed and performance of many analogues.
          </p>
          <p>Email:  <a itemscope itemprop="email"  :href="`mailto:${CONTACTS.email}`" class="link">{{ CONTACTS.email }}</a></p>
        </div>
        <div class="main-page-header-logo">
          <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g transform="scale(1.15) translate(-15, -15)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M23 18H217V187.394H213.735V21.2751H29.5606L88.8841 100.001L53.7584 147.001H88.7552L106.443 123.958L124.258 147.653L121.652 149.625L106.416 129.362L90.3618 150.276H47.2303L84.7976 100.009L23 18ZM121.683 50.7507H164.475L127.515 100.008L213.735 214.658H165.832V211.382H207.222L123.434 100.001L157.931 54.0257H123.32L106.156 77.0894L88.5443 53.3663L91.1628 51.4101L106.159 71.6104L121.683 50.7507ZM26.2648 211.382V52.3882H23V214.658H34.9993V211.382H26.2648Z" fill="white"/>
              <path d="M150.158 211.197H157.454V214.327H150.158V218.107H158.056V221.238H146.835V204.382H158.056V207.513H150.158V211.197Z" fill="white"/>
              <path d="M130.306 204.382H136.036C140.756 204.382 143.357 207.175 143.357 210.739C143.357 213.243 142.008 215.146 139.721 216.037C140.443 216.494 141.189 217.361 142.225 218.998L143.67 221.238H139.937L138.854 219.552C137.553 217.554 137.144 217.168 135.483 217.12H133.629V221.238H130.306V204.382ZM133.629 207.513V213.99H136.35C138.517 213.99 140.202 213.003 140.202 210.739C140.202 208.596 138.517 207.513 136.35 207.513H133.629Z" fill="white"/>
              <path d="M116.302 218.156L115.098 221.238H111.414L118.348 204.382H120.299L127.137 221.238H123.453L122.249 218.156H116.302ZM119.287 210.402L117.457 215.001H121.093L119.287 210.402Z" fill="white"/>
              <path d="M109.513 204.382V214.158C109.513 219.022 106.214 221.406 102.675 221.406C99.1112 221.406 95.8364 219.022 95.8364 214.158V204.382H99.1593V214.086C99.1593 217.241 100.917 218.276 102.675 218.276C104.433 218.276 106.19 217.241 106.19 214.086V204.382H109.513Z" fill="white"/>
              <path d="M83.3851 204.213C88.1287 204.213 91.9813 208.066 91.9813 212.81C91.9813 215.025 90.9941 217.023 89.5012 218.276H92.8723V221.406H83.3851C78.6416 221.406 74.813 217.577 74.813 212.81C74.813 208.066 78.6416 204.213 83.3851 204.213ZM83.3851 207.344C80.4475 207.344 78.1359 209.583 78.1359 212.81C78.1359 216.06 80.4475 218.276 83.3851 218.276C86.3468 218.276 88.6584 216.06 88.6584 212.81C88.6584 209.583 86.3468 207.344 83.3851 207.344Z" fill="white"/>
              <path d="M65.3488 204.213H65.5414C67.9252 204.213 70.3091 205.369 72.0428 207.007L69.8756 209.005C68.6235 207.994 66.7695 207.344 65.5414 207.344H65.3488C64.2412 207.344 62.4352 207.753 62.4352 209.222C62.4352 210.354 63.7355 210.691 65.2525 210.883L66.6009 211.028C70.0201 211.437 72.5725 212.713 72.5725 216.205C72.5725 219.407 69.7553 221.382 66.023 221.406H65.8785C62.5075 221.406 60.0514 219.817 58.7271 218.011L60.8942 216.012C61.6406 217.072 63.3743 218.276 65.8785 218.276H66.023C67.9734 218.251 69.2496 217.481 69.2496 216.205C69.2496 214.736 67.8771 214.327 66.1434 214.11L64.819 213.965C61.5925 213.58 59.1123 212.304 59.1123 209.342C59.1123 206.188 61.8573 204.262 65.3488 204.213Z" fill="white"/>
              <path d="M49.0977 215.507L45.221 221.238H41.4165L47.2677 212.449L41.8018 204.382H45.5822L49.17 209.535L52.6855 204.382H56.4659L51 212.593L56.8512 221.238H53.0708L49.0977 215.507Z" fill="white"/>
            </g>
          </svg>
        </div>
      </template>
    </page-header>
  </div>
</template>

<style lang="scss" scoped>
.about-page-header {
  &:deep(.main-page-header) {
      margin-bottom: 0;
    .main-page-header {
      &-container {
        display: grid;
        grid-template-columns: 400px 1fr;
        grid-template-rows: auto minmax(0, 1fr);
        padding-top: 0;
        padding-bottom: 0;
        @include onMD {
          grid-template-columns: 250px 1fr;
        }
        @include onSM {
          display: flex;
          flex-direction: column;
        }
      }

      &__h1 {
        grid-column: 1 / span 1;
        grid-row: 1 / span 1;
        padding-bottom: 40px;
        border-bottom: 1px $GRAY_LINE solid;
        margin-bottom: 0;
        padding-top: 40px;
        @include onMD {
          padding-bottom: 25px;
          padding-top: 25px;
        }
      }

      &-description {
        @include font-size(24px);
        color: #FFF;
        font-weight: 400;
        line-height: 1.5em;
        letter-spacing: -0.96px;
        grid-column: 2 / span 1;
        grid-row: 1 / span 2;
        border-left: 1px $GRAY_LINE solid;
        padding-left: 75px;
        padding-top: 70px;
        padding-bottom: 80px;
        @include onMD {
          padding-left: 35px;
          padding-top: 30px;
          padding-bottom: 40px;
        }

        @include onSM {
          padding: 10px 0;
          border: none;
          padding-bottom: 40px;
        }

        p, h2 {
          margin-bottom: 1.5em;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &-logo {
        grid-column: 1 / span 1;
        grid-row: 2 / span 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        @include onSM {
          display: none;
        }

        svg {
          width: 100%;
          height: auto;
          max-height: 280px;
        }
      }
    }
  }
}
.contacts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  @include onXS {
    display: flex;
    flex-direction: column;
  }
  &-info {
    ul {
      display: flex;
      flex-direction: column;
      gap: 40px;
      color: $GRAY_TEXT;
      @include onXS {
        gap: 20px;
      }

      li {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .name {
          @include font-size(16px);
          --min-font-size: 14px;
          font-weight: 400;
          line-height: 1.3em;
        }
        .value {
          color: $GRAY_TEXT_DARK;
          @include font-size(22px);
          --min-font-size: 16px;
          line-height: 1.3em;

          &:is(a) {
            color: $VIOLET;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }

        :deep(.additional) {
          @include font-size(16px);
          display: block;
          font-weight: 600;
          color: $VIOLET;
        }
      }
    }
  }

  .map {
    min-height: 400px;
    box-shadow: 0px 0px 6px 0px rgba(86, 154, 233, 0.15);
    border-radius: var(--main-border-radius);
    overflow: hidden;
    @include onMD {
      max-width: 50vw;
      min-height: 250px;
      height: 250px;
    }
    @include onXS {
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>
